/**
 * Shared track helpers used by `@verybigthings/trackframe-hub`,
 * `@verybigthings/trackframe-hub-client` and the hub admin SPA. Kept in its own
 * subpath (imported as `@verybigthings/trackframe-shared/tracks`) so consumers
 * don't pull the schemas barrel's `FormatRegistry` side effects into edge
 * runtimes — same rationale as `./http`.
 */
/**
 * Human label for a track: `displayName` when set, otherwise the registration
 * slug. Every user-facing surface must resolve the label through this — the
 * homepage cards and the header's track picker both shipped the raw slug
 * because each had its own idea of the rule.
 *
 * A whitespace-only `displayName` counts as unset: it renders as an empty
 * label, which is strictly worse than showing the slug.
 */
export function trackLabel(track) {
    return track.displayName?.trim() || track.name;
}
//# sourceMappingURL=tracks.js.map